import { api } from '@/auth/api';

/**
 * Setup-wizard funnel beacons (allowlisted server-side, once-only per
 * fleet+name). Fire-and-forget: a beacon must never block or break the
 * flow, so failures are swallowed. Completion events are NOT sent from
 * here — they stay server-derived (checklist_rates_confirmed on the tariff
 * PUT, checklist_brand_set from the brand columns).
 */
export type SetupWizardEvent =
  | 'wizard_rates_started'
  | 'wizard_rates_skipped'
  | 'wizard_brand_started'
  | 'wizard_brand_skipped'
  | 'wizard_done_viewed'
  | 'wizard_domain_started'
  | 'wizard_domain_purchased'
  | 'wizard_domain_fell_back'
  | 'wizard_domain_byo_chosen'
  | 'wizard_booking_page_ready';

export function recordSetupEvent(
  fleetId: string,
  name: SetupWizardEvent,
  opts?: { durationMs?: number },
): void {
  void api(`/v1/fleets/${fleetId}/setup-events`, {
    method: 'POST',
    body: { name, ...(opts?.durationMs !== undefined ? { durationMs: opts.durationMs } : {}) },
  }).catch(() => undefined);
}

/** Per-tab skip markers so a refresh resumes at the right step. */
export const wizardSkips = {
  key: (fleetId: string, step: 'rates' | 'brand') => `breaker-wiz-skip:${fleetId}:${step}`,
  set(fleetId: string, step: 'rates' | 'brand'): void {
    try {
      sessionStorage.setItem(this.key(fleetId, step), '1');
    } catch {
      /* storage unavailable — resume just re-offers the step */
    }
  },
  has(fleetId: string, step: 'rates' | 'brand'): boolean {
    try {
      return sessionStorage.getItem(this.key(fleetId, step)) === '1';
    } catch {
      return false;
    }
  },
};
